export const STARTING_RATING = 1500;
export const OVERALL_K_FACTOR = 32;

export const DIFFICULTY_RATINGS = {
    Easy: 1000,
    Medium: 1500,
    Hard: 2000,
};

export function getCategoryKFactor(attempts) {
  if (attempts < 5) return 128;
  if (attempts < 10) return 96;
  if (attempts < 20) return 64;
  if (attempts < 30) return 48;

  return 32;
}

export function calculateNewRating(
    currentRating,
    difficulty,
    result,
    kFactor = OVERALL_K_FACTOR
) {
    const clueRating =
        DIFFICULTY_RATINGS[difficulty] ?? STARTING_RATING;

    const expected =
        1 /
        (1 +
            10 **
            ((clueRating - currentRating) / 400));

    const newRating =
        currentRating +
        kFactor * (result - expected);

    return Math.round(newRating * 100) / 100;
}